import RichText from '../rich-text'
import { cx } from '@/utils/strings'
import { isPrint } from '@/utils/print'

export default function Callout({ title, body }: Props): JSX.Element {
  const isPrintView = isPrint()
  return (
    <div
      className={cx(
        ' mb-4 border break-inside-avoid p-4 [&_p]:last:mb-0! rounded-lg',
        isPrintView ? '[&_p]:mb-3 bg-secondary-50' : 'md:p-6 bg-bw-teal-light-highlight dark:bg-secondary-800'
      )}
    >
      {title && <h4 className="text-xl mb-2 mt-0">{title}</h4>}
      <RichText body={body} />
    </div>
  )
}
